<template>
  <v-layout row wrap>
    <v-flex xs12 mt-5>
      <dialog-consumables
        @addConsumable="addItemConsumables"
        ref="dialogConsumables"
      />
      <v-layout row wrap justify-end align-center>
        <v-flex xs8>
          <h2>Materiais de Consumo</h2>
        </v-flex>

        <v-flex offset-xs2 xs2>
          <div
            v-if="
              isContractInitialPage && materials.consumables.itens.length > 0
            "
            style="width:80%;float:right"
          >
            <v-switch
              v-model="materials.consumables.automaticShipping"
              @change="updateStatusSwitch('consumables')"
              label="Envio Automático"
            ></v-switch>
          </div>
          <div v-else style="text-align:right">
            <v-btn
              fab
              dark
              small
              color="primary"
              class="mb-2"
              :disabled="contractFinished"
              @click.prevent="OpenDialogConsumables"
            >
              <v-icon dark>add</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <!--{{materials.consumables.items}}-->
      <v-data-table
        :loading="loading"
        :headers="consumablesHeader"
        :search="search"
        :items="materials.consumables.itens"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.description }}</td>
          <td class="text-xs-center">{{ props.item.unity }}</td>
          <td class="text-xs-center">{{ props.item.quantity || 0 }}</td>
          <td class="text-xs-center">
            {{ utilFormatter.setFormatValue(props.item.value) }}
          </td>
          <td class="text-xs-center" v-if="!isContractInitialPage">
            {{
              utilFormatter.setFormatValue(
                props.item.value * props.item.quantity
              )
            }}
          </td>
          <td class="text-xs-center">{{ props.item.lifetime || 0 }}</td>
          <td class="text-xs-center" v-if="isContractInitialPage">
            <input
              type="number"
              v-model="props.item.quantityApproved"
              class="input-quantity"
            />
          </td>
          <td class="text-xs-center" v-if="isContractInitialPage">
            <input
              type="number"
              v-model="props.item.shippingFrequency.quantity"
              class="input-quantity"
            />
          </td>
          <!--   <v-btn :disabled="loading" @click="edit(props.item)" title="Editar registro" color="info" flat icon round>
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn :disabled="loading" @click="officceRemove = props.item; dialogRemove = true;" title="Excluir registro"
            color="error" flat icon round>
            <v-icon>delete</v-icon>
          </v-btn>-->
          <td class="justify-center layout px-0 text-xs-center" v-else>
            <v-icon
              color="info"
              small
              class="mr-2"
              :disabled="contractFinished"
              @click="OpenDialogConsumablesForEdition(props.item)"
              >edit</v-icon
            >
            <v-icon
              color="error"
              small
              :disabled="contractFinished"
              @click="OpenDialogConsumablesForDelete(props.item)"
              >delete</v-icon
            >
          </td>
          <td class="text-xs-center" v-if="isContractInitialPage">
            <v-layout row align-center justify-center>
              <v-flex xs2>
                <v-switch
                  v-model="props.item.shippingFrequency.automaticShipping"
                ></v-switch>
              </v-flex>
            </v-layout>
          </td>
        </template>
        <template slot="no-data">
          <strong>{{ footerDynamicText }}</strong>
        </template>
      </v-data-table>
      <alert-delete
        ref="alertToDeleteComsumableItem"
        @deleteItem="removeConsumableItem"
      ></alert-delete>
    </v-flex>
    <!-- MATERIAIS DE CONSUMO -->

    <!-- EQUIPAMENTOS -->
    <v-flex xs12 mt-5>
      <dialog-equipments
        @addEquipment="addItemEquipment"
        ref="dialogEquipments"
      />
      <v-layout row wrap justify-end align-center>
        <v-flex xs8>
          <h2>Equipamentos</h2>
        </v-flex>

        <v-flex offset-xs2 xs2>
          <div
            v-if="
              isContractInitialPage && materials.equipments.itens.length > 0
            "
            style="width:80%;float:right"
          >
            <v-switch
              v-model="materials.equipments.automaticShipping"
              @change="updateStatusSwitch('equipments')"
              label="Envio Automático"
            ></v-switch>
          </div>
          <div v-else style="text-align:right">
            <v-btn
              fab
              dark
              small
              color="primary"
              class="mb-2"
              :disabled="contractFinished"
              @click.prevent="OpenDialogEquipments"
            >
              <v-icon dark>add</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <!--{{materials.equipments.items}}-->
      <v-data-table
        :loading="loading"
        :headers="equipmentsHeaders"
        :search="search"
        :items="materials.equipments.itens"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.description }}</td>
          <td class="text-xs-center">{{ props.item.stamp }}</td>
          <td class="text-xs-center">{{ props.item.quantity || 0 }}</td>
          <td class="text-xs-center">
            {{ utilFormatter.setFormatValue(props.item.value) }}
          </td>
          <td class="text-xs-center" v-if="!isContractInitialPage">
            {{
              utilFormatter.setFormatValue(
                props.item.value * props.item.quantity
              )
            }}
          </td>
          <td class="text-xs-center">{{ props.item.lifetime }}</td>
          <td class="text-xs-center" v-if="isContractInitialPage">
            <input
              type="number"
              v-model="props.item.quantityApproved"
              class="input-quantity"
            />
          </td>
          <td class="text-xs-center" v-if="isContractInitialPage">
            <input
              type="number"
              v-model="props.item.shippingFrequency.quantity"
              class="input-quantity"
            />
          
          </td>
          <td class="justify-center layout px-0 text-xs-center" v-else>
            <v-icon
              small
              color="info"
              class="mr-2"
              :disabled="contractFinished"
              @click="OpenDialogEquipmentsForEdition(props.item)"
              >edit</v-icon
            >
            <v-icon
              small
              color="error"
              :disabled="contractFinished"
              @click="OpenDialogEquipmentsForDelete(props.item)"
              >delete</v-icon
            >
          </td>
          <td class="text-xs-center" v-if="isContractInitialPage">
            <v-layout row align-center justify-center>
              <v-flex xs2>
                <v-switch
                  v-model="props.item.shippingFrequency.automaticShipping"
                ></v-switch>
              </v-flex>
            </v-layout>
          </td>
        </template>
        <template slot="no-data">
          <strong>{{ footerDynamicText }}</strong>
        </template>
      </v-data-table>
      <alert-delete
        ref="alertToDeleteEquipmentItem"
        @deleteItem="removeEquipmentItem"
      ></alert-delete>
    </v-flex>
    <!-- EQUIPAMENTOS -->

    <!-- UTENSÍLIOS -->
    <v-flex xs12 mt-5>
      <dialog-utensils @addUtensil="addItemUtensil" ref="dialogUtensils" />
      <v-layout row wrap justify-end align-center>
        <v-flex xs8>
          <h2>Utensilios</h2>
        </v-flex>

        <v-flex offset-xs2 xs2>
          <div
            v-if="isContractInitialPage && materials.utensils.itens.length > 0"
            style="width:80%;float:right"
          >
            <v-switch
              v-model="materials.utensils.automaticShipping"
              @change="updateStatusSwitch('utensils')"
              label="Envio Automático"
            ></v-switch>
          </div>
          <div v-else style="text-align:right">
            <v-btn
              fab
              dark
              small
              color="primary"
              class="mb-2"
              :disabled="contractFinished"
              @click.prevent="OpenDialogUtensils"
            >
              <v-icon dark>add</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <!--{{materials.utensils.itens}}-->
      <v-data-table
        :headers="utensilHeaders"
        :search="search"
        hide-actions
        :items="materials.utensils.itens"
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.description }}</td>
          <td class="text-xs-center">{{ props.item.unity }}</td>
          <td class="text-xs-center">{{ props.item.quantity || 0 }}</td>
          <td class="text-xs-center">
            {{ utilFormatter.setFormatValue(props.item.value) }}
          </td>
          <td class="text-xs-center" v-if="!isContractInitialPage">
            {{
              utilFormatter.setFormatValue(
                props.item.value * props.item.quantity
              )
            }}
          </td>
          <td class="text-xs-center">{{ props.item.lifetime }}</td>
          <td class="text-xs-center" v-if="isContractInitialPage">
            <input
              type="number"
              v-model="props.item.quantityApproved"
              class="input-quantity"
            />
          </td>
          <td class="text-xs-center" v-if="isContractInitialPage">
            <input
              type="number"
              v-model="props.item.shippingFrequency.quantity"
              mask="##"
              class="input-quantity"
            />
          </td>
          <!--     <td class="text-xs-center">{{ utilFormatter.setFormatValue(amountCalculate(props.item))}}</td> -->
          <td class="justify-center layout px-0" v-else>
            <v-icon
              small
              color="info"
              :disabled="contractFinished"
              class="mr-2"
              @click="OpenDialogUtensilsForEdition(props.item)"
              >edit</v-icon
            >
            <v-icon
              small
              color="error"
              :disabled="contractFinished"
              @click="OpenDialogUtensilsForDelete(props.item)"
              >delete</v-icon
            >
          </td>
          <td class="text-xs-center" v-if="isContractInitialPage">
            <v-layout row align-center justify-center>
              <v-flex xs2>
                <v-switch
                  v-model="props.item.shippingFrequency.automaticShipping"
                ></v-switch>
              </v-flex>
            </v-layout>
          </td>
        </template>
        <template slot="no-data">
          <strong>{{ footerDynamicText }}</strong>
        </template>
      </v-data-table>
      <alert-delete
        ref="alertToDeleteUtensilItem"
        @deleteItem="removeUtensilItem"
      ></alert-delete>
    </v-flex>
    <!-- UTENSÍLIOS -->

    <!-- UNIFORMES E EPIS -->
    <v-flex xs12 mt-5>
      <DialogUniformAndEPIs
        @addUniformAndEPI="addItemUniformAndEPIs"
        ref="dialogUniformAndEPIs"
      />
      <v-layout row wrap justify-end align-center>
        <v-flex xs8>
          <h2>Uniformes e EPI's</h2>
        </v-flex>

        <v-flex offset-xs2 xs2>
          <div
            style="width:80%;float:right"
            v-if="
              isContractInitialPage &&
                materials.uniformsAndEPIs.itens.length > 0
            "
          >
            <v-switch
              v-model="materials.uniformsAndEPIs.automaticShipping"
              @change="updateStatusSwitch('uniformsAndEPIs')"
              label="Envio Automático"
            ></v-switch>
          </div>
          <div v-else style="text-align:right">
            <v-btn
              fab
              dark
              small
              color="primary"
              class="mb-2"
              :disabled="contractFinished"
              @click.prevent="OpenDialogUniformAndEPIs"
            >
              <v-icon dark>add</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <!--{{materials.uniformsAndEPIs.items}}-->
      <v-data-table
        :headers="uniformsAndEPIsHeaders"
        :search="search"
        :items="materials.uniformsAndEPIs.itens"
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.description }}</td>
          <td class="text-xs-center">{{ props.item.unity }}</td>
          <td class="text-xs-center">{{ props.item.quantity || 0 }}</td>
          <td class="text-xs-center">
            {{ utilFormatter.setFormatValue(props.item.value) }}
          </td>
          <td class="text-xs-center" v-if="!isContractInitialPage">
            {{
              utilFormatter.setFormatValue(
                props.item.value * props.item.quantity
              )
            }}
          </td>
          <td class="text-xs-center">{{ props.item.lifetime }}</td>
          <td class="text-xs-center" v-if="isContractInitialPage">
            <input
              type="number"
              v-model="props.item.quantityApproved"
              class="input-quantity"
            />
          </td>
          <td class="text-xs-center" v-if="isContractInitialPage">
            <input
              type="number"    
              v-model.number="props.item.shippingFrequency.quantity"
              mask="##"

              class="input-quantity"
            />
<!--             <v-text-field  v-model="props.item.shippingFrequency.quantity" box  mask="##" ></v-text-field> -->
          </td>
          <!--  <td class="text-xs-center">{{ utilFormatter.setFormatValue(amountCalculate(props.item))}}</td> -->
          <td class="justify-center layout px-0" v-else>
            <v-icon
              small
              color="info"
              class="mr-2"
              :disabled="contractFinished"
              @click="OpenDialogUniformAndEPIsForEdition(props.item)"
              >edit</v-icon
            >
            <v-icon
              small
              color="error"
              :disabled="contractFinished"
              @click="OpenDialogUniformAndEPIsForDelete(props.item)"
              >delete</v-icon
            >
          </td>
          <td class="text-xs-center" v-if="isContractInitialPage">
            <v-layout row align-center justify-center>
              <v-flex xs2>
                <v-switch
                  v-model="props.item.shippingFrequency.automaticShipping"
                ></v-switch>
              </v-flex>
            </v-layout>
          </td>
        </template>

        <template slot="no-data">
          <strong>{{ footerDynamicText }}</strong>
        </template>
      </v-data-table>
      <alert-delete
        ref="alertToDeleteUniformAndEPIsItem"
        @deleteItem="removeUniformItem"
      ></alert-delete>
    </v-flex>
    <!-- UNIFORMES E EPIS -->
  </v-layout>
</template>
<script>
import Headers from "../../../data/headers/ContractHeaders";
import HeadersInitialContract from "../../../data/headers/InitialContractsHeaders";
import DialogUniformAndEPIs from "../dialogs/DialogUniformAndEPIs";
import DialogUtensils from "../dialogs/DialogUtensil";
import DialogEquipments from "../dialogs/DialogEquipments";
import DialogConsumables from "../dialogs/DialogConsumables";
import UtilFormatter from "../../../utils/UtilFormatter";
import AlertDelete from "./../../AlertDelete";

export default {
  props: {
    contractFinished: {
      type: Boolean,
      default: false
    },
    isContractInitialPage: {
      type: Boolean,
      default: false
    }
  },
  beforeMount() {
    this.getHeaders();
  },
  data() {
    return {
      //Headers
      utilFormatter: UtilFormatter,
      consumablesHeader: [],
      equipmentsHeaders: [],
      utensilHeaders: [],
      uniformsAndEPIsHeaders: [],
      materials: {
        consumables: {
          itens: []
        },
        equipments: {
          itens: []
        },
        uniformsAndEPIs: {
          itens: []
        },
        utensils: {
          itens: []
        }
      },
     
      emptyRecordsText: "Nenhum registro encontrado",
      emptySearchText: "Nenhum registro encontrado para",
      editMaterialItem: false,
      editMaterialItemIndex: -1,
      loading: false,
      search: "",
      editingSheet: {}
    };
  },
  components: {
    AlertDelete,
    DialogUniformAndEPIs,
    DialogUtensils,
    DialogEquipments,
    DialogConsumables
  },

  methods: {
    getHeaders() {
      // esse metodo busca os cabeçalhos de um arquivo externo
      this.consumablesHeader = Headers.getConsumablesHeaders();
      this.equipmentsHeaders = Headers.getEquipamentHeaders();
      this.utensilHeaders = Headers.getUtencilHeaders();
      this.uniformsAndEPIsHeaders = Headers.getUniformsAndEPIsHeaders();
    },

    getHeadersFinishedContract() {
      // esse metodo busca os cabeçalhos de um arquivo externo
      this.consumablesHeader = HeadersInitialContract.getConsumablesHeaders();
      this.equipmentsHeaders = HeadersInitialContract.getEquipamentHeaders();
      this.utensilHeaders = HeadersInitialContract.getUtencilHeaders();
      this.uniformsAndEPIsHeaders = HeadersInitialContract.getUniformsAndEPIsHeaders();
    },
    //table
    loadTables(materials) {
      this.materials = {}
      this.materials = materials;
      console.log(this.materials);
    },

    save() {
      let mat = this.materials;

      this.materials = {
        consumables: {
          itens: []
        },
        equipments: {
          itens: []
        },
        uniformsAndEPIs: {
          itens: []
        },
        utensils: {
          itens: []
        }
      };
      return mat;
    },
    //table
    /*INICIO: METODOS REFERENTE AOS DIALOGS DE CADASTRO DE ITENS DO SETOR */
    //UniformAndEPIs
    OpenDialogUniformAndEPIs() {
      this.$refs.dialogUniformAndEPIs.addNewItem();
    },
    OpenDialogUniformAndEPIsForDelete(item) {
      this.$refs.alertToDeleteUniformAndEPIsItem.openDialog(item);
    },
    OpenDialogUniformAndEPIsForEdition(item) {
      this.editMaterialItem = true;
      this.editMaterialItemIndex = this.materials.uniformsAndEPIs.items.indexOf(
        item
      );
      this.$refs.dialogUniformAndEPIs.editItem(item);
    },
    addItemUniformAndEPIs(item) {
      if (this.editMaterialItem) {
        this.materials.uniformsAndEPIs.items[this.editMaterialItemIndex] = item;
        this.editMaterialItemIndex = -1;
        this.editMaterialItem = false;
      } else {
        this.materials.uniformsAndEPIs.items.push(item);
      }
    },

    removeUniformItem(item) {
      const index = this.materials.uniformsAndEPIs.items.indexOf(item);
      this.materials.uniformsAndEPIs.items.splice(index, 1);
    },
    /* UniformsAndEPIs */

    //Utencils
    OpenDialogUtensils() {
      this.$refs.dialogUtensils.addNewItem();
    },
    OpenDialogUtensilsForEdition(item) {
      this.editMaterialItem = true;
      this.editMaterialItemIndex = this.materials.utensils.itens.indexOf(item);
      this.$refs.dialogUtensils.editItem(item);
    },
    OpenDialogUtensilsForDelete(item) {
      this.$refs.alertToDeleteUtensilItem.openDialog(item);
    },

    addItemUtensil(item) {
      if (this.editMaterialItem) {
        this.materials.utensils.itens[this.editMaterialItemIndex] = item;
        this.editMaterialItemIndex = -1;
        this.editMaterialItem = false;
      } else {
        this.materials.utensils.itens.push(item);
      }
    },
    removeUtensilItem(item) {
      const index = this.materials.utensils.itens.indexOf(item);
      this.materials.utensils.itens.splice(index, 1);
    },
    /* Utensils */

    //Equipaments
    OpenDialogEquipments() {
      this.$refs.dialogEquipments.addNewItem();
    },
    OpenDialogEquipmentsForDelete(item) {
      this.$refs.alertToDeleteEquipmentItem.openDialog(item);
    },
    OpenDialogEquipmentsForEdition(item) {
      this.editMaterialItem = true;
      this.editMaterialItemIndex = this.materials.equipments.itens.indexOf(
        item
      );
      this.$refs.dialogEquipments.editItem(item);
    },
    addItemEquipment(item) {
      if (this.editMaterialItem) {
        this.materials.equipments.itens[this.editMaterialItemIndex] = item;
        this.editMaterialItemIndex = -1;
        this.editMaterialItem = false;
      } else {
        this.materials.equipments.itens.push(item);
      }
    },
    removeEquipmentItem(item) {
      const index = this.materials.equipments.itens.indexOf(item);
      this.materials.equipments.itens.splice(index, 1);
    },
    /* Equipments */

    //Consumables
    OpenDialogConsumables() {
      this.$refs.dialogConsumables.addNewItem();
    },
    OpenDialogConsumablesForDelete(item) {
      this.$refs.alertToDeleteComsumableItem.openDialog(item);
    },
    OpenDialogConsumablesForEdition(item) {
      this.editMaterialItem = true;
      this.editMaterialItemIndex = this.materials.consumables.itens.indexOf(
        item
      );
      this.$refs.dialogConsumables.editItem(item);
    },
    addItemConsumables(item) {
      if (this.editMaterialItem) {
        this.materials.consumables.itens[this.editMaterialItemIndex] = item;
        this.editMaterialItemIndex = -1;
        this.editMaterialItem = false;
      } else {
        this.materials.consumables.itens.push(item);
      }
    },

    removeConsumableItem(item) {
      const index = this.materials.consumables.itens.indexOf(item);
      this.materials.consumables.itens.splice(index, 1);
    },
    /* Consumables */

    /*FIM: METODOS REFERENTE AOS DIALOGS DE CADASTRO DE ITENS DO SETOR */

    /* SWITCH */
    updateStatusSwitch(material) {
      const items = this.materials[material].itens;
      for (let index = 0; index < items.length; index++) {
        items[index].shippingFrequency.automaticShipping = this.materials[
          material
        ].automaticShipping;
      }
    },

    /* SWITCH */
    resetAll() {
      this.materials = {
        consumables: {
          itens: []
        },
        equipments: {
          itens: []
        },
        uniformsAndEPIs: {
          itens: []
        },
        utensils: {
          itens: []
        }
      };
    }
  },
  computed: {
    footerDynamicText() {
      let text = this.loading ? this.loadingRecordsText : this.emptyRecordsText;
      return text;
    }
  },
  beforeDestroy() {
    this.resetAll();
  }
};
</script>
<style scoped>
.input-quantity {
  border-bottom: solid thin rgb(73, 73, 73);
  background-color: rgb(216, 216, 216);
  border-radius: 5px 5px 0px 0px;
  padding: 3px;
  font-size: 9pt;
}
</style>



// WEBPACK FOOTER //
// src/components/contract/department/Tables.vue